import { api } from "../../services/api";

// Cache de imagens de anexo (módulo, não state): a rota /chatanexo/:id exige JWT,
// então a imagem não pode ir direto no src — precisa vir por blob + objectURL.
// O cache evita rebaixar o mesmo arquivo na miniatura, no visualizador e a cada
// remontagem do balão (trocar de conversa, fechar/abrir o widget).

const MAX_CACHE = 40;

const urls: Record<number, string> = {};
const pendentes: Record<number, Promise<string>> = {};
const ordem: number[] = [];   // ids na ordem de entrada, para descartar os mais antigos

function guardar(id: number, url: string) {
    urls[id] = url;
    ordem.push(id);
    while (ordem.length > MAX_CACHE) {
        const antigo = ordem.shift();
        if (antigo === undefined || antigo === id) continue;
        const urlAntiga = urls[antigo];
        if (urlAntiga) {
            window.URL.revokeObjectURL(urlAntiga);
            delete urls[antigo];
        }
    }
}

// URL já disponível em memória (null = ainda não baixada)
export function urlImagemCache(id: number): string | null {
    return urls[id] || null;
}

export function carregarImagemAnexo(id: number, mime: string): Promise<string> {
    const pronta = urls[id];
    if (pronta) return Promise.resolve(pronta);

    const emAndamento = pendentes[id];
    if (emAndamento) return emAndamento;

    const requisicao = api
        .get(`/chatanexo/${id}`, { responseType: 'blob' })
        .then(response => {
            // o tipo vem do banco: sem ele o objectURL não renderiza como imagem
            const url = window.URL.createObjectURL(new Blob([response.data], { type: mime || 'image/jpeg' }));
            guardar(id, url);
            delete pendentes[id];
            return url;
        })
        .catch(erro => {
            delete pendentes[id];
            throw erro;
        });

    pendentes[id] = requisicao;
    return requisicao;
}
